<template>
    <Spinner v-if="subscriberStore.isLoading" />
    <Navbar />

    <div class="container">
        <div class="row justify-content-center mb-3">
            <div class="col">
                <select id="select-company-app-id" class="form-select" v-model="subscriberStore.filters.companyAppId" @change="subscriberStore.filterSubscriptions()">
                    <option :value="null" :selected="null">{{ $t('LABEL_ALL_SUBSCRIPTIONS') }}</option>
                    <option v-for="(app, i) in subscriberStore.registeredApps" :key="i" :value="app.company_app_id">{{ app.site_name }}</option>
                </select>
            </div>

            <div class="col">
                <input id="next-payment-date-from" type="date" class="form-control" v-model="subscriberStore.filters.nextPaymentDateFrom" @change="subscriberStore.filterSubscriptions()">
            </div>

            <div class="col">
                <input id="next-payment-date-to" type="date" class="form-control" v-model="subscriberStore.filters.nextPaymentDateTo" @change="subscriberStore.filterSubscriptions()">
            </div>
        </div>

        <div class="row">
            <div v-if="subscriberStore.errorMessage.length > 0" class="alert alert-danger col-12" role="alert">
                {{ subscriberStore.errorMessage }}
            </div>
        </div>

        <div class="row">
            <div v-if="subscriberStore.filteredSubscriptions.length > 0"
                 v-for="(subscription, i) in subscriberStore.filteredSubscriptions"
                 :key="i"
                 class="col-sm-12 col-md-3 mb-3 ">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ subscription.site_name }}</h5>
                        <h6 class="card-subtitle mb-2 text-muted">{{ subscription.subscription_type }}</h6>
                        <p>subscriber id : {{ subscription.subscriber_id }}</p>
                        <p>next payment date : {{ subscription.next_payment_date }}</p>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="alert alert-info text-center" role="alert">
                    {{ $t('INFO_MESSAGE_NO_SUBSCRIPTION') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Spinner from "@/components/Spinner.vue";
import {useSubscriberStore} from "@/stores/subscriberStore";
import {onMounted} from "vue";
import Navbar from "@/components/Navbar.vue";
import {useTopPageStore} from "@/stores/topPageStore";

const subscriberStore = useSubscriberStore();

onMounted(async () => {
    await subscriberStore.getSubscribers();
    subscriberStore.registeredApps = useTopPageStore().registeredApps;
});

</script>